import { Text } from '@lego/klik-ui';
import { UserNameLink } from '@/components/common/UserNameLink';
import type { ApplicationVersionListResponse } from '@/hooks/application_version';
import { dateTimeFormat } from '@/utility/date';
import { createColumnHelper } from '../appTable';
import { dateRange } from '../filters/filterFunctions';

type ApplicationVersionResponse = ApplicationVersionListResponse['applicationVersions'][number];

const columnHelper = createColumnHelper<ApplicationVersionResponse>();

export const applicationVersionTableColumns = columnHelper.columns([
  columnHelper.accessor('id', {
    cell: (info) => (
      <Text fontFamily="mono" fontSize="sm">
        {info.getValue()}
      </Text>
    ),
    filterFn: 'includesString',
    header: 'ID',
    meta: { filterVariant: { constraint: /^[0-9]*$/, type: 'singleSearch' } },
    size: 96,
  }),
  columnHelper.accessor('version', {
    cell: (info) => (
      <Text fontFamily="mono" fontSize="sm">
        {info.getValue()}
      </Text>
    ),
    filterFn: 'includesString',
    header: 'Version',
    meta: { filterVariant: { constraint: /^[0-9]*$/, type: 'singleSearch' } },
  }),
  columnHelper.accessor('tag', {
    cell: (info) => (
      <Text fontFamily="mono" fontSize="sm">
        {info.getValue()}
      </Text>
    ),
    filterFn: 'includesString',
    header: 'Tag',
    meta: { filterVariant: { type: 'singleSearch' } },
  }),
  columnHelper.accessor('createdByOid', {
    cell: (info) => <UserNameLink oid={info.getValue()} />,
    enableSorting: false,
    header: 'Created By',
  }),
  columnHelper.accessor('createdAt', {
    cell: (info) => new Date(info.getValue()).toLocaleString(dateTimeFormat.local),
    filterFn: dateRange,
    header: 'Created At',
    meta: { filterVariant: { type: 'dateRange' } },
  }),
]);
